import { styled } from '@mui/system';

export const StyledRoot = styled('div')(({ theme }) => ({
  padding: theme.spacing(),
  marginTop: theme.spacing(),
  maxWidth: '700px',
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(16)
  }
}));

export const CompanyImgCnt = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(6),
  height: 148,
  display: 'flex',
  alignItems: 'center'
}));

export const CompanyImgLogo = styled('img')(() => ({
  height: 100,
  maxWidth: 246,
  margin: '0 auto'
}));
